/* src/app/forms/wizard-configuracao/setup-integration-view/setup-integration-view.component.scss */
.finish {
  padding: 16px;
  display: flex;
  width: 100%;
}
.separatorCenter {
  text-align: center;
}
.content {
  height: calc(100% - 116px);
  width: 100%;
  display: flex;
}
:host ::ng-deep .mat-tab-body-content {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.content > * {
  width: 100%;
}
.mat-mdc-form-field {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=setup-integration-view.component.css.map */
